import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import OAuth from "../components/OAuth";
import Photo from "../assets/Pictures/linas.png";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  function onChange(e) {
    setEmail(e.target.value);
  }

  async function onSubmit(e) {
    e.preventDefault();
    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      toast.success(t("email_sent"));
    } catch (error) {
      toast.error(t("reset_password_error"));
    }
  }

  return (
    <section>
      <h1 className="text-3xl text-center mt-6 font-bold">{t("forgot_password")}</h1>
      <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-6xl mx-auto">
        <div className="md:w-[67%] lg:w-[50%] mb-12 md:mb-6">
          <img
            src={Photo}
            alt="key"
            className="w-full rounded-2xl"
          />
        </div>
        <div className="w-full md:w-[67%] lg:w-[40%] lg:ms-20">
          <form onSubmit={onSubmit}>
            <input
              type="email"
              id="email"
              value={email}
              onChange={onChange}
              placeholder={t("email_placeholder")}
              className="mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
            />

            <div className="flex justify-between whitespace-nowrap text-sm sm:text-lg">
              <p className="mb-6">
                {t("no_account")}{" "}
                <Link
                  to="/signup"
                  className="text-red-600 hover:text-red-700 transition duration-200 ease-in-out ms-1"
                >
                  {t("sign_up")}
                </Link>
              </p>
              <p>
                <Link
                  to="/signin"
                  className="text-gray-600 hover:text-gray-800 transition duration-200 ease-in-out"
                >
                  {t("sign_in")}
                </Link>
              </p>
            </div>
            <button
              className="w-full bg-gray-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-gray-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-gray-800"
              type="submit"
            >
              {t("reset_password")}
            </button>
            <div className="flex items-center my-4 before:border-t before:flex-1 before:border-gray-300 after:border-t after:flex-1 after:border-gray-300">
              <p className="text-center font-semibold mx-4">{t("or")}</p>
            </div>
            <OAuth />
          </form>
        </div>
      </div>
    </section>
  );
}
